export let props = {
  // 图片地址的前缀host可选
  host: String,
  // 图片的地址
  src: String,
  // 图片的名称
  alt: String,
  /**
   * 组件主体为img标签，将使用满高宽，由组件内的最外层容器决定宽度。
   * 所以这里确定的是img-box的高度，这里这是minHeight是为了让无图片时，
   * 容器还能有高度撑起，其实不怎么实用，应该用height
   */
  minHeight: {
    type: String,
    default: () => '100%'
  },
  /**
   * 就像上面说的一样，img-box应该有个固定高度，或实用minHeight,从而让外层组件决定高
   */
  height: {
    type: String,
    default: () => '100%'
  },
  /**
   * img标签的 object-fit 属性，默认contain，
   * 可参考 https://www.runoob.com/cssref/pr-object-fit.html
   */
  objectFit: {
    type: String,
    default: 'contain'
  }
};
//  ['host', 'src', 'alt', 'minHeight','height',]
export let model = {
  fail: false,
  loading: false,
  realWidth: 0,
  isStationImgServer: false,
  stationImgServerFail: false
};
export let computed = {
  hostSrc() {
    let result = '';
    if (!this.src) {
      return result;
    }
    if (this.host && !(/^(http)/.test(this.src))) {
      result =  this.host + this.src;
    } else if ((/^(http)/.test(this.src))) {
      result = this.src;
    } else {
      result = window.CONFIG.IMG_SERVER ? (window.CONFIG.IMG_SERVER + this.src) : this.src;
    }
    return result + '?x-oss-process=image/resize,h_300,m_lfit';
  },
  text() {
    let noimg = !this.hostSrc;
    let noalt = !this.alt;
    let failimg = this.fail;
    if (noimg) {
      if (noalt) {
        return '暂无图片';
      } else {
        return `暂无${this.alt}`;
      }
    }
    if (failimg) {
      if (noalt) {
        // return '图片加载失败'
        return '暂无图片';
      } else {
        // return `${this.alt}加载失败`
        return `暂无${this.alt}`;
      }
    }
    if (noalt) {
      return '图片加载中';
    } else {
      return `${this.alt}加载中`;
    }
  },
  boxStyle() {
    // let style = {
    //   width: this.width || '100%',
    //   minHeight: this.minHeight || 'auto'
    // }
    // if (this.ratio && this.realWidth) {
    //   style.height = this.realWidth/this.ratio + 'px'
    // } else {
    //   style.height = this.height || '100%'
    // }
    // 同时存在最小高和高，使用height
    if (this.minHeight && this.height) {
      return {
        height: this.height,
      };
    }
    if (this.minHeight && !this.height) {
      return {
        minHeight: this.minHeight
      };
    }
    if (this.height && !this.minHeight) {
      return {
        height: this.height,
      };
    }
    return {
      minHeight: this.minHeight
    };
  },
  imgStyle() {
    if (this.loading) {
      return {
        display: 'none'
      };
    } else {
      return {
        objectFit: this.objectFit
      };
    }
  },
  showImg() {
    return this.src && !this.fail && !this.loading;
  },
};
